import { useParams } from 'react-router-dom'

export default function RedirectWhatsapp() {
    const { id } = useParams()

    // redireciona imediatamente
    window.location.replace(`https://api.whatsapp.com/send/?phone=${id}`)

    return null
}
